export default __webpack_public_path__ + "static/media/g2022-13.4e786bf8.jpeg";